(() => {
  if (window.twwMobileChatGuard) return;
  window.twwMobileChatGuard = true;
  const script = document.querySelector('script[data-tww-chat-guard]');
  const gap = Math.max(8, Math.min(32, Number(script?.dataset.gap) || 12));
  const mobile = matchMedia('(max-width:749px)');
  const selectors = 'form[action*="/cart/add"] [name="add"], .shopify-payment-button, button[name="checkout"], input[name="checkout"], button[name="goto_pp"]';
  let frame = 0, host, shift = 0;
  const observedRoots = new Map();

  const queue = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const visible = element => {
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && getComputedStyle(element).visibility !== 'hidden'
      && rect.bottom > 0 && rect.top < innerHeight;
  };
  const overlaps = (a, b) => a.left < b.right + gap && a.right > b.left - gap
    && a.top < b.bottom + gap && a.bottom > b.top - gap;
  function setShift(value) {
    value = Math.floor(value);
    if (value === shift) return;
    shift = value;
    host.style.setProperty('--tww-chat-shift', `${shift}px`);
  }
  function update() {
    frame = 0;
    const current = document.querySelector('shopify-chat');
    if (!current) return;
    if (host !== current) {
      host?.style.removeProperty('--tww-chat-shift');
      host = current;
      shift = 0;
    }
    // Inbox upgrades its lightweight launcher to a nested agent runtime on
    // first open. Follow both exposed shadow roots without touching chat data.
    const shadow = host.shadowRoot;
    const runtime = shadow?.querySelector('shopify-agent-runtime');
    const roots = [shadow, runtime?.shadowRoot].filter(Boolean);
    for (const [root, observer] of observedRoots) {
      if (!roots.includes(root)) {
        observer.disconnect();
        root.removeEventListener('transitionend', queue);
        root.removeEventListener('animationend', queue);
        observedRoots.delete(root);
      }
    }
    for (const root of roots) {
      if (observedRoots.has(root)) continue;
      const observer = new MutationObserver(queue);
      observer.observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['class','aria-expanded','open','shell-ready']});
      root.addEventListener('transitionend', queue);
      root.addEventListener('animationend', queue);
      observedRoots.set(root, observer);
    }
    const button = roots.map(root => root.querySelector('[part~="activator"]')).find(Boolean);
    if (!mobile.matches || !button || button.getAttribute('aria-expanded') === 'true' || !visible(button)) {
      setShift(0);
      return;
    }
    const actual = button.getBoundingClientRect();
    const baseline = {left:actual.left, right:actual.right, top:actual.top-shift, bottom:actual.bottom-shift};
    const controls = Array.from(document.querySelectorAll(selectors))
      .filter(visible).map(e => e.getBoundingClientRect())
      .filter(r => baseline.left < r.right + gap && baseline.right > r.left - gap);
    if (!controls.some(r => overlaps(baseline,r))) {
      setShift(0);
      return;
    }
    const stickyHeader = document.querySelector('.shopify-section-header-sticky');
    const headerBottom = stickyHeader && visible(stickyHeader) ? Math.max(0,stickyHeader.getBoundingClientRect().bottom) : 0;
    const topLimit = Math.max(gap,headerBottom+gap);
    // Prefer the nearest clear position above purchase controls. Never move below
    // the app's original position, preserving its preview-bar and safe-area spacing.
    const candidates = [0,...controls.map(r => r.top-gap-baseline.bottom)]
      .filter(y => y <= 0 && baseline.top+y >= topLimit).sort((a,b) => b-a);
    const chosen = candidates.find(y => !controls.some(r => overlaps({...baseline,top:baseline.top+y,bottom:baseline.bottom+y},r)));
    setShift(chosen === undefined ? 0 : chosen);
  }
  addEventListener('scroll',queue,{passive:true});
  addEventListener('resize',queue,{passive:true});
  addEventListener('pageshow',queue);
  document.addEventListener('scroll',queue,{passive:true,capture:true});
  // Drawer controls move into the viewport after their active class changes.
  // Recalculate at the end of that movement, not only at animation start.
  document.addEventListener('transitionend',queue,true);
  document.addEventListener('animationend',queue,true);
  mobile.addEventListener('change',queue);
  window.visualViewport?.addEventListener('resize',queue,{passive:true});
  new MutationObserver(queue).observe(document.body,{childList:true,subtree:true});
  document.querySelectorAll('cart-drawer').forEach(drawer => {
    new MutationObserver(queue).observe(drawer,{attributes:true,attributeFilter:['class']});
  });
  customElements.whenDefined('shopify-chat').then(queue);
  queue();
})();
